
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class EmailTemplatesDialog extends Serenity.EntityDialog<EmailTemplatesRow, any> {
        protected getFormKey() { return EmailTemplatesForm.formKey; }
        protected getIdProperty() { return EmailTemplatesRow.idProperty; }
        protected getLocalTextPrefix() { return EmailTemplatesRow.localTextPrefix; }
        protected getNameProperty() { return EmailTemplatesRow.nameProperty; }
        protected getService() { return EmailTemplatesService.baseUrl; }
        protected getDeletePermission() { return EmailTemplatesRow.deletePermission; }
        protected getInsertPermission() { return EmailTemplatesRow.insertPermission; }
        protected getUpdatePermission() { return EmailTemplatesRow.updatePermission; }

        protected form = new EmailTemplatesForm(this.idPrefix);

    }
}